import { useEffect } from "react";

export default function JsonLd({ schemas }) {
    useEffect(() => {
        if (!schemas || schemas.length === 0) {
            return;
        }

        const elements = schemas.map((schema, index) => {
            const script = document.createElement("script");

            script.type = "application/ld+json";
            script.dataset.jsonLd = `schema-${index}`;
            script.text = JSON.stringify(schema);

            document.head.appendChild(script);

            return script;
        });

        return () => {
            elements.forEach((element) => {
                document.head.removeChild(element);
            });
        };
    }, [schemas]);

    return null;
}
